import { OptionTitle } from "./OptionTitle"

export const AmabAfabPreferenceOptions: Array<OptionTitle> = [
  { title: "Yes, I'd like to answer questions related to ovarian/uterine health", id: "AFAB_PREF" },
  { title: "Yes, I'd like to answer questions related to sperm health", id: "AMAB_PREF" },
  { title: "No, I'd prefer not to answer health questions right now", id: "DECLINED_HEALTH_QS" },
  { title: "Yes", id: "PREF_UNAVAILABLE_FOR_JOURNEY" }
]
